import { Role } from '@zorro/clients';
import { Loader } from '@zorro/design-system/v2/Loader';
import { useMonolithQuery, useRoles } from '@zorro/web/ui-utils';

import { PlanYearsTable } from '../../PlanYearsTable';
import {
  CompanySetupTabType,
  CompanySetupTabWrapper,
} from '../CompanySetupTabWrapper';

type Props = {
  employerId: string;
  isDon: boolean;
};

export const PlanYearSetupTab = ({ employerId, isDon }: Props) => {
  const { userRoles } = useRoles();

  const isEditable = userRoles.some((role) =>
    [Role.OPERATOR, Role.OMNIPOTENT_ADMIN, Role.ACCOUNT_SUPERVISOR].includes(
      role
    )
  );

  const { data: employer, isLoading } = useMonolithQuery({
    method: 'employersControllerFindOne',
    params: [employerId],
  });

  return (
    <CompanySetupTabWrapper
      tab={CompanySetupTabType.PLAN_YEAR_SETUP}
      employerId={employerId}
      isDon={isDon}
    >
      {employer && !isLoading ? (
        <PlanYearsTable
          employerName={employer.name}
          employerId={employer.id}
          isEditable={isEditable}
        />
      ) : (
        <Loader />
      )}
    </CompanySetupTabWrapper>
  );
};
